import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  divider: {
    margin: "4px 0 4px 0",
  },
}));
